export const companyPaymentGatewaysConstants = {
  // Payment Gateways
  COMPANY_PAYMENT_GATEWAYS_FETCH_REQUEST: 'COMPANY_PAYMENT_GATEWAYS_FETCH_REQUEST',
  COMPANY_PAYMENT_GATEWAYS_FETCH_SUCCESS: 'COMPANY_PAYMENT_GATEWAYS_FETCH_SUCCESS',
  COMPANY_PAYMENT_GATEWAYS_FETCH_FAILURE: 'COMPANY_PAYMENT_GATEWAYS_FETCH_FAILURE',

  COMPANY_PAYMENT_GATEWAY_CREATE_REQUEST: 'COMPANY_PAYMENT_GATEWAY_CREATE_REQUEST',
  COMPANY_PAYMENT_GATEWAY_CREATE_SUCCESS: 'COMPANY_PAYMENT_GATEWAY_CREATE_SUCCESS',
  COMPANY_PAYMENT_GATEWAY_CREATE_FAILURE: 'COMPANY_PAYMENT_GATEWAY_CREATE_FAILURE',

  COMPANY_PAYMENT_GATEWAY_UPDATE_REQUEST: 'COMPANY_PAYMENT_GATEWAY_UPDATE_REQUEST',
  COMPANY_PAYMENT_GATEWAY_UPDATE_SUCCESS: 'COMPANY_PAYMENT_GATEWAY_UPDATE_SUCCESS',
  COMPANY_PAYMENT_GATEWAY_UPDATE_FAILURE: 'COMPANY_PAYMENT_GATEWAY_UPDATE_FAILURE',

  COMPANY_PAYMENT_GATEWAY_DELETE_REQUEST: 'COMPANY_PAYMENT_GATEWAY_DELETE_REQUEST',
  COMPANY_PAYMENT_GATEWAY_DELETE_SUCCESS: 'COMPANY_PAYMENT_GATEWAY_DELETE_SUCCESS',
  COMPANY_PAYMENT_GATEWAY_DELETE_FAILURE: 'COMPANY_PAYMENT_GATEWAY_DELETE_FAILURE',

  COMPANY_PAYMENT_GATEWAY_FETCH_BY_ID_REQUEST:
    'COMPANY_PAYMENT_GATEWAY_FETCH_BY_ID_REQUEST',
  COMPANY_PAYMENT_GATEWAY_FETCH_BY_ID_SUCCESS:
    'COMPANY_PAYMENT_GATEWAY_FETCH_BY_ID_SUCCESS',
  COMPANY_PAYMENT_GATEWAY_FETCH_BY_ID_FAILURE:
    'COMPANY_PAYMENT_GATEWAY_FETCH_BY_ID_FAILURE',

  COMPANY_PAYMENT_GATEWAY_PERFORM_ACTION_REQUEST:
    'COMPANY_PAYMENT_GATEWAY_PERFORM_ACTION_REQUEST',
  COMPANY_PAYMENT_GATEWAY_PERFORM_ACTION_SUCCESS:
    'COMPANY_PAYMENT_GATEWAY_PERFORM_ACTION_SUCCESS',
  COMPANY_PAYMENT_GATEWAY_PERFORM_ACTION_FAILURE:
    'COMPANY_PAYMENT_GATEWAY_PERFORM_ACTION_FAILURE',

  // Payment Gateway Webhooks
  COMPANY_PAYMENT_GATEWAY_WEBHOOKS_FETCH_REQUEST:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOKS_FETCH_REQUEST',
  COMPANY_PAYMENT_GATEWAY_WEBHOOKS_FETCH_SUCCESS:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOKS_FETCH_SUCCESS',
  COMPANY_PAYMENT_GATEWAY_WEBHOOKS_FETCH_FAILURE:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOKS_FETCH_FAILURE',

  COMPANY_PAYMENT_GATEWAY_WEBHOOK_CREATE_REQUEST:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOK_CREATE_REQUEST',
  COMPANY_PAYMENT_GATEWAY_WEBHOOK_CREATE_SUCCESS:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOK_CREATE_SUCCESS',
  COMPANY_PAYMENT_GATEWAY_WEBHOOK_CREATE_FAILURE:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOK_CREATE_FAILURE',

  COMPANY_PAYMENT_GATEWAY_WEBHOOK_UPDATE_REQUEST:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOK_UPDATE_REQUEST',
  COMPANY_PAYMENT_GATEWAY_WEBHOOK_UPDATE_SUCCESS:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOK_UPDATE_SUCCESS',
  COMPANY_PAYMENT_GATEWAY_WEBHOOK_UPDATE_FAILURE:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOK_UPDATE_FAILURE',

  COMPANY_PAYMENT_GATEWAY_WEBHOOK_DELETE_REQUEST:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOK_DELETE_REQUEST',
  COMPANY_PAYMENT_GATEWAY_WEBHOOK_DELETE_SUCCESS:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOK_DELETE_SUCCESS',
  COMPANY_PAYMENT_GATEWAY_WEBHOOK_DELETE_FAILURE:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOK_DELETE_FAILURE',

  COMPANY_PAYMENT_GATEWAY_WEBHOOK_EVENTS_FETCH_REQUEST:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOK_EVENTS_FETCH_REQUEST',
  COMPANY_PAYMENT_GATEWAY_WEBHOOK_EVENTS_FETCH_SUCCESS:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOK_EVENTS_FETCH_SUCCESS',
  COMPANY_PAYMENT_GATEWAY_WEBHOOK_EVENTS_FETCH_FAILURE:
    'COMPANY_PAYMENT_GATEWAY_WEBHOOK_EVENTS_FETCH_FAILURE',

  // Available Payment Gateways
  COMPANY_PAYMENT_GATEWAYS_FETCH_AVAILABLE_REQUEST:
    'COMPANY_PAYMENT_GATEWAYS_FETCH_AVAILABLE_REQUEST',
  COMPANY_PAYMENT_GATEWAYS_FETCH_AVAILABLE_SUCCESS:
    'COMPANY_PAYMENT_GATEWAYS_FETCH_AVAILABLE_SUCCESS',
  COMPANY_PAYMENT_GATEWAYS_FETCH_AVAILABLE_FAILURE:
    'COMPANY_PAYMENT_GATEWAYS_FETCH_AVAILABLE_FAILURE',

  // Payment Methods
  COMPANY_PAYMENT_METHODS_FETCH_REQUEST: 'COMPANY_PAYMENT_METHODS_FETCH_REQUEST',
  COMPANY_PAYMENT_METHODS_FETCH_SUCCESS: 'COMPANY_PAYMENT_METHODS_FETCH_SUCCESS',
  COMPANY_PAYMENT_METHODS_FETCH_FAILURE: 'COMPANY_PAYMENT_METHODS_FETCH_FAILURE',

  // Charge Status
  COMPANY_CHARGE_STATUS_FETCH_REQUEST: 'COMPANY_CHARGE_STATUS_FETCH_REQUEST',
  COMPANY_CHARGE_STATUS_FETCH_SUCCESS: 'COMPANY_CHARGE_STATUS_FETCH_SUCCESS',
  COMPANY_CHARGE_STATUS_FETCH_FAILURE: 'COMPANY_CHARGE_STATUS_FETCH_FAILURE',
};
